
// ==============================
// LRC — Checkout Drawer (open/close)
// ==============================
(function initLrcCheckoutDrawer() {
    const getEls = () => ({
        overlay: document.querySelector('[data-lrc-checkout-overlay]'),
        panel: document.querySelector('[data-lrc-checkout-panel]')
    });

    const lockScroll = () => document.documentElement.classList.add('checkout-drawer-open');
    const unlockScroll = () => document.documentElement.classList.remove('checkout-drawer-open');

    // ---------- Condition evaluator ----------
    async function evaluateAndShowUpsellBlock() {
        const blocks = document.querySelectorAll('[data-lrc-block]');
        if (!blocks.length) return;

        let cart;
        try {
            const res = await fetch('/cart.js');
            cart = await res.json();
        } catch (e) {
            // On fetch failure, show first block
            blocks[0].style.display = 'block';
            return;
        }

        const total = cart.total_price / 100;
        const items = cart.items || [];

        // Resolve the viewed-but-not-in-cart candidate once, up front, so the
        // synchronous condition evaluator can just ask whether one exists.
        let dynCandidate = null;
        try {
            const needsDyn = Array.from(blocks).some(b =>
                (b.dataset.conditions || '').indexOf('viewed_not_in_cart') > -1 ||
                b.hasAttribute('data-dynamic-upsell'));
            if (needsDyn && window.LRC_DYN && window.LRC_DYN.findCandidate) {
                // cache intentionally preserved - warmed on cart-drawer open
                // Each block may restrict to different handles, so resolve per block.
                for (const b of blocks) {
                    const c = await window.LRC_DYN.findCandidate(cart, b.getAttribute('data-dyn-only-handles'));
                    b.__dynCandidate = c;
                    if (c && !dynCandidate) dynCandidate = c;
                }
            }
        } catch (e) { dynCandidate = null; }

        function evalCondition(type, value) {
            if (!type || type === 'none') return null;
            const ids = value ? value.split(',').map(s => s.trim()) : [];
            switch (type) {
                case 'cart_total_min':  return total >= parseFloat(value || 0);
                case 'cart_total_max':  return total <  parseFloat(value || 0);
                case 'variant_contains':  return ids.some(id => items.some(i => String(i.variant_id) === id));
                case 'variant_excludes':  return !ids.some(id => items.some(i => String(i.variant_id) === id));
                case 'product_contains':  return ids.some(id => items.some(i => String(i.product_id) === id));
                case 'product_excludes':  return !ids.some(id => items.some(i => String(i.product_id) === id));
                case 'subscription_true':  return items.some(i => i.selling_plan_allocation);
                case 'subscription_false': return !items.some(i => i.selling_plan_allocation);
                case 'viewed_not_in_cart': return !!(evalBlock && evalBlock.__dynCandidate);
                default: return null;
            }
        }

        // Parse condition string: "a1:cart_total_min:35|b1:subscription_true:|"
        function parseConditions(str) {
            // Returns {a: [{type,value},...], b: [...], c: [...], d: [...]}
            const groups = { a: [], b: [], c: [], d: [] };
            if (!str) return groups;
            str.split('|').forEach(part => {
                if (!part) return;
                const [key, type, ...rest] = part.split(':');
                if (!key || !type) return;
                const g = key[0]; // 'a', 'b', 'c', 'd'
                if (groups[g]) groups[g].push({ type, value: rest.join(':') });
            });
            return groups;
        }

        let evalBlock = null;
        function blockPasses(condStr) {
            const groups = parseConditions(condStr);
            for (const g of ['a', 'b', 'c', 'd']) {
                const slots = groups[g];
                if (!slots.length) continue; // empty group passes
                // OR within group
                const groupPasses = slots.some(s => evalCondition(s.type, s.value) === true);
                if (!groupPasses) return false; // AND across groups
            }
            return true;
        }

        console.log('[LRC] evaluating', blocks.length, 'blocks, cart total:', total);
        blocks.forEach(b => console.log('[LRC] block conditions:', b.dataset.conditions, '→ passes:', (evalBlock = b, blockPasses(b.dataset.conditions || ''))));

        const blockArray = Array.from(blocks);

        // A/B: a block is eligible if it carries no experiment, or its
        // experiment has no running assignment, or its arm is the assigned one.
        // With an empty registry LRC_EXP is undefined and every block is eligible,
        // so behaviour is identical to first-passing-block-wins.
        function expEligible(b) {
            const k = b.dataset.expKey;
            const a = b.dataset.expArmId;
            if (!k || !a) return true;
            const assigned = (window.LRC_EXP && window.LRC_EXP.assigned) || null;
            if (!assigned || !assigned[k]) return true;
            return assigned[k] === a;
        }

        let winner = blockArray.find(b => (evalBlock = b, blockPasses(b.dataset.conditions || '')) && expEligible(b));
        if (!winner) winner = blockArray.find(b => (evalBlock = b, blockPasses(b.dataset.conditions || '')));
        if (!winner) winner = blockArray[0];
        blockArray.forEach(block => {
            if (block !== winner) {
                block.remove();
            }
        });
        winner.style.display = 'block';

        // Dynamic offer: rewrite the block to the most recently viewed
        // out-of-cart variant. Silent no-op when nothing qualifies.
        if (winner.hasAttribute('data-dynamic-upsell') && window.LRC_DYN) {
            try { await window.LRC_DYN.swap(winner, winner.__dynCandidate || null); } catch (e) {}
        }
        // Reveal unconditionally - a failed or skipped swap must never leave
        // the block hidden.
        winner.removeAttribute('data-dyn-pending');

        // Remember the winning arm for accept/decline events, and count the exposure.
        try {
            const wk = winner.dataset.expKey, wa = winner.dataset.expArmId;
            if (wk && wa && window.LRC_EXP && window.LRC_EXP.assigned && window.LRC_EXP.assigned[wk] === wa) {
                window.__lrcPpuArm = { key: wk, arm: wa };
                if (typeof window.LRC_EXP.expose === 'function') window.LRC_EXP.expose(wk, wa);
            } else {
                window.__lrcPpuArm = null;
            }
        } catch (e) { window.__lrcPpuArm = null; }
    }

    function openCheckout(opener, skipUpsell) {
        const { overlay, panel } = getEls();
        if (!overlay || !panel) return;
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
        panel.style.transform = 'translateX(0)';
        panel.setAttribute('aria-hidden', 'false');
        if (!skipUpsell) evaluateAndShowUpsellBlock();
        lockScroll();
        requestAnimationFrame(() => {
            const focusable = panel.querySelector('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            focusable && focusable.focus({ preventScroll: true });
        });
        openCheckout.lastOpener = opener || document.activeElement;
    }

    function closeCheckout() {
        const { overlay, panel } = getEls();
        if (!overlay || !panel) return;
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
        panel.style.transform = 'translateX(110%)';

        const onEnd = (e) => {
            if (e && e.target !== panel) return;
            panel.removeEventListener('transitionend', onEnd, true);
            panel.setAttribute('aria-hidden', 'true');
            unlockScroll();
            const opener = openCheckout.lastOpener;
            if (opener && document.contains(opener)) opener.focus?.({ preventScroll: true });
        };
        panel.addEventListener('transitionend', onEnd, true);

        // (Fallback if transitionend is missed)
        setTimeout(() => {
            panel.removeEventListener('transitionend', onEnd, true);
            panel.setAttribute('aria-hidden', 'true');
            unlockScroll();
        }, 900);
    }

    // Delegated clicks (works if header re-renders)
    document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-lrc-checkout-open]');
        if (openBtn) { e.preventDefault(); openCheckout(openBtn); return; }
        const closeBtn = e.target.closest('[data-lrc-checkout-close]');
        if (closeBtn) { e.preventDefault(); closeCheckout(); return; }
    });

    // ESC to close
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeCheckout();
    });

    // Public API (optional)
    window.lrcCheckoutDrawer = {
        open: (skipUpsell) => openCheckout(null, skipUpsell),
        close: closeCheckout,
        toggle: () => {
            const { panel } = getEls();
            if (!panel) return;
            const isClosed = getComputedStyle(panel).transform.includes('matrix(1, 0, 0, 1, 0, 0)') === false &&
                panel.style.transform.includes('100%');
            isClosed ? openCheckout() : closeCheckout();
        }
    };
})();


// ===============================================
// LRC — Checkout Drawer actions & navigation
// ===============================================
(function lrcCheckoutActions() {
    const CHECKOUT_URL = '/checkout';
    const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
    const $ = (sel, root = document) => root.querySelector(sel);

    // ---------- helpers ----------
    function safeParseJSON(str) {
        if (!str || typeof str !== 'string') return null;
        try { return JSON.parse(str); } catch { return null; }
    }

    // FIX: Tailwind's `.hidden{display:none!important}` → must toggle the class, not just style
    function setLoading(el, loading) {
        if (!el) return;
        const sp = el.querySelector('[data-spinner]');
        if (loading) {
            el.dataset.lrcLoading = '1';
            el.disabled = true;
            el.classList.add('opacity-50', 'pointer-events-none');
            if (sp) { sp.classList.remove('hidden'); sp.style.display = ''; }
        } else {
            delete el.dataset.lrcLoading;
            el.disabled = false;
            el.classList.remove('opacity-50', 'pointer-events-none');
            if (sp) { sp.classList.add('hidden'); sp.style.display = 'none'; }
        }
    }

    // Track last click so goToCheckout() can show spinner even without an argument
    let __lrcLastClickTarget = null;
    document.addEventListener('click', (e) => { __lrcLastClickTarget = e.target; }, { capture: true });

    function ensureSpinnerNode(btn) {
        if (!btn) return;
        let sp = btn.querySelector('[data-spinner]');
        if (!sp) {
            sp = document.createElement('span');
            sp.setAttribute('data-spinner', '');
            sp.className = 'ml-2 hidden';
            sp.innerHTML = `
        <svg class="animate-spin h-5 w-5 text-cyan-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>`;
            btn.appendChild(sp);
        }
    }

    function findBestCheckoutTrigger(explicitBtn) {
        if (explicitBtn) return explicitBtn;

        const fromLastClick = __lrcLastClickTarget &&
            __lrcLastClickTarget.closest('.lrc-drawer-go-to-checkout, a.lrc-drawer-go-to-checkout, button.lrc-drawer-add-to-cart-checkout, a.lrc-drawer-add-to-cart-checkout');
        if (fromLastClick) return fromLastClick;

        const active = document.activeElement;
        if (active) {
            const fromActive = active.closest('.lrc-drawer-go-to-checkout, a.lrc-drawer-go-to-checkout, button.lrc-drawer-add-to-cart-checkout, a.lrc-drawer-add-to-cart-checkout');
            if (fromActive) return fromActive;
        }

        return document.querySelector('.lrc-drawer-go-to-checkout, a.lrc-drawer-go-to-checkout');
    }

    let __lrcNavigating = false;

    // ---------- Unified goToCheckout (works from anywhere) ----------
    async function goToCheckout(triggerBtn) {
        if (__lrcNavigating) return;
        __lrcNavigating = true;

        const trigger = findBestCheckoutTrigger(triggerBtn);
        if (trigger) ensureSpinnerNode(trigger);
        if (trigger) setLoading(trigger, true);

        let finalCartData = null;
        try {
            const ps = window.lrcPlanSync;
            if (ps && typeof ps.getStatus === 'function' && typeof ps.waitForCompleteStrict === 'function') {
                const status = ps.getStatus() || {};
                if (status.state === 'running') {
                    await ps.waitForCompleteStrict();
                }
            }

            if (typeof window.lrcFlushPendingOps === 'function') {
                // await window.lrcFlushPendingOps(); // waits until flush completes
                finalCartData = await window.lrcFlushPendingOps(); // waits until flush completes
            }
        } catch (e) {
            console.warn('[LRC] flush failed before checkout:', e);
            // continue anyway
        } finally {
            const cart = finalCartData?.finalCart
            const cart_sub_discount = cart?.items.reduce((sum, li) => sum + (li?.selling_plan_allocation && Number(li?.selling_plan_allocation?.compare_at_price - li?.selling_plan_allocation?.per_delivery_price) || 0), 0);
            //console.log('cart_sub_discount: ', cart_sub_discount);
            // --- START: Klaviyo "Started Checkout"
            try {
                document.dispatchEvent(new CustomEvent('lrc:checkout-started'));
                window.LRC_klaviyo?.track?.("Checkout Started", {
                    cart_items: cart?.items || [],
                    checkout_total_cart_value: cart.total_price / 100,
                    total_price: cart.total_price / 100,
                    total_compare_at_price: (cart?.total_price + cart_sub_discount + cart?.total_discount) / 100,
                    cart_item_count: cart.item_count,
                    currency: cart.currency || "{{ shop.currency }}",
                    shopify_total_discount: cart.total_discount || 0,
                    subscription_total_discount: cart_sub_discount / 100,
                });
            } catch (e) { /* no-op */ }
            // --- END: Klaviyo "Started Checkout"
            try { window.location.assign(CHECKOUT_URL); }
            catch { window.location.href = CHECKOUT_URL; }
        }
    }

    // Expose if other scripts need it
    window.lrcGoToCheckout = goToCheckout;

    // ---------- Add-to-cart then Checkout ----------
    async function addToCartAndCheckout(btn) {
        const variantId = Number(btn?.dataset?.variantId || btn?.getAttribute('data-variant-id'));
        const qty = Math.max(1, Number(btn?.dataset?.qty || 1));
        const sellingPlanId = btn?.dataset?.sellingPlanId ? Number(btn.dataset.sellingPlanId) : null;
        const props = safeParseJSON(btn?.dataset?.properties);

        if (!Number.isFinite(variantId)) {
            console.warn('[LRC] Missing data-variant-id on .lrc-drawer-add-to-cart-checkout');
            goToCheckout(); // fallback
            return;
        }

        const line = { id: variantId, quantity: qty };
        if (sellingPlanId) line.selling_plan = sellingPlanId;
        if (props && typeof props === 'object') line.properties = props;

        setLoading(btn, true);

        try {
            const ps = window.lrcPlanSync;
            if (ps && typeof ps.getStatus === 'function' && typeof ps.waitForCompleteStrict === 'function') {
                const status = ps.getStatus() || {};
                if (status.state === 'running') {
                    await ps.waitForCompleteStrict();
                }
            }

            if (typeof window.lrcFlushPendingOps === 'function') {
                await window.lrcFlushPendingOps();
            }
        } catch (e) {
            console.warn('[LRC] flush failed before add+checkout:', e);
        }

        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [line] }),
                credentials: 'same-origin',
            });

            if (!res.ok) {
                let msg = 'Could not add to cart. Please try again.';
                try {
                    const data = await res.json();
                    if (data && (data.description || data.message)) msg = data.description || data.message;
                } catch { }
                alert(msg);
                setLoading(btn, false);
                return;
            }

            if (typeof window.lrcRefreshHeaderCartCount === 'function') {
                try { await window.lrcRefreshHeaderCartCount(); } catch { }
            }

            // We don't pass btn; unified goToCheckout will still find a trigger and show spinner
            // goToCheckout();
            const cart = await fetch('/cart.js', {
                headers: { 'Accept': 'application/json' }
            }).then(r => r.json());
            const cart_sub_discount = cart?.items.reduce((sum, li) => sum + (li?.selling_plan_allocation && Number(li?.selling_plan_allocation?.compare_at_price - li?.selling_plan_allocation?.per_delivery_price) || 0), 0);

            // --- START: Klaviyo "Started Checkout"
            try {
                document.dispatchEvent(new CustomEvent('lrc:checkout-started'));
                window.LRC_klaviyo?.track?.("Checkout Started", {
                    cart_items: cart?.items || [],
                    checkout_total_cart_value: cart.total_price / 100,
                    total_price: cart.total_price / 100,
                    total_compare_at_price: (cart?.total_price + cart_sub_discount + cart?.total_discount) / 100,
                    cart_item_count: cart.item_count,
                    currency: cart.currency || "{{ shop.currency }}",
                    shopify_total_discount: cart.total_discount || 0,
                    subscription_total_discount: cart_sub_discount / 100,
                });
            } catch (e) { /* no-op */ }

            const discountCode = (btn.dataset.discountCode || '').trim();
            let dest = CHECKOUT_URL;
            if (discountCode) {
                dest = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(CHECKOUT_URL);
            }
            try { window.location.assign(dest); } catch (e) { window.location.href = dest; }
        } catch (err) {
            console.error('[LRC] addToCart error', err);
            alert('Network error adding to cart. Please try again.');
            setLoading(btn, false);
        }
    }

    // ---------- Multi-layout variant dropdown ----------
    document.addEventListener('change', (e) => {
        const sel = e.target.closest('select.lrc-multi-variant-select');
        if (!sel) return;

        const slot = sel.dataset.slot;
        const card = sel.closest('[data-slot="' + slot + '"].lrc-multi-card');
        if (!card) return;

        const selectedOption = sel.options[sel.selectedIndex];
        const newVariantId   = selectedOption.value;
        const newPrice       = parseInt(selectedOption.dataset.price, 10);
        const newCompareAt   = parseInt(selectedOption.dataset.compareAt || '0', 10);

        // Update ATC button variant
        const atcBtn = card.querySelector('button.lrc-drawer-add-to-cart-checkout');
        if (atcBtn) atcBtn.dataset.variantId = newVariantId;

        // Per-offer discount math (mirrors the Liquid math): discount the selected variant price,
        // strike the compare-at (or the raw price) when higher than the discounted price.
        const dType = atcBtn ? (atcBtn.dataset.discountType || 'none') : 'none';
        const dValue = atcBtn ? (atcBtn.dataset.discountValue || '0') : '0';
        const finalPrice = lrcApplyDiscount(newPrice, dType, dValue);
        const struckPrice = (newCompareAt && newCompareAt > finalPrice) ? newCompareAt : (newPrice > finalPrice ? newPrice : null);

        // Update discount badge and ATC label
        const badge = card.querySelector('.lrc-discount-badge');
        const atcLabelSpan = atcBtn ? atcBtn.querySelector('span:first-child') : null;
        const atcBaseText = atcBtn ? (atcBtn.dataset.atcBaseLabel || atcBtn.querySelector('span:first-child').textContent.split(' — ')[0].trim()) : '';

        // Store base label on first change
        if (atcBtn && !atcBtn.dataset.atcBaseLabel) {
            atcBtn.dataset.atcBaseLabel = atcBaseText;
        }

        let discountText = '';
        if (struckPrice != null && struckPrice > finalPrice) {
            const savingsAmount = struckPrice - finalPrice;
            const savingsPercent = Math.round(savingsAmount * 100 / struckPrice);
            const badgeType = card.closest('#lrc-multi-product-cards') ? card.closest('#lrc-multi-product-cards').dataset.badgeType : '';
            if (badgeType === 'percent') {
                discountText = savingsPercent + '% OFF';
            } else if (badgeType === 'amount') {
                discountText = 'SAVE ' + formatMoney(savingsAmount);
            }
        }

        if (badge) {
            if (discountText) {
                badge.textContent = discountText;
                badge.style.display = '';
            } else {
                badge.style.display = 'none';
            }
        }

        if (atcLabelSpan && atcBtn.dataset.atcBaseLabel) {
            atcLabelSpan.textContent = discountText
                ? atcBtn.dataset.atcBaseLabel + ' — ' + discountText
                : atcBtn.dataset.atcBaseLabel;
        }

        // Update product image
        const productImg = card.querySelector('.lrc-multi-card-product-img');
        const newImage = selectedOption.dataset.image;
        if (productImg && newImage) {
            productImg.src = newImage;
        }

        // Update price display
        const priceRow = card.querySelector('.lrc-multi-price-row');
        if (priceRow) {
            const priceEl      = priceRow.querySelector('.lrc-multi-price');
            const compareAtEl  = priceRow.querySelector('.lrc-multi-compare-at');

            if (priceEl) {
                priceEl.textContent = formatMoney(finalPrice);
            }
            if (struckPrice != null && struckPrice > finalPrice) {
                if (compareAtEl) {
                    compareAtEl.textContent = formatMoney(struckPrice);
                    compareAtEl.style.display = '';
                } else {
                    const span = document.createElement('span');
                    span.className = 'lrc-multi-compare-at line-through text-neutral-400 text-xs';
                    span.textContent = formatMoney(struckPrice);
                    priceRow.insertBefore(span, priceEl);
                }
            } else if (compareAtEl) {
                compareAtEl.style.display = 'none';
            }
        }
    });

    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    // Mirrors the Liquid per-offer discount math (cents in, discounted cents out).
    function lrcApplyDiscount(cents, type, value) {
        const v = parseFloat(value) || 0;
        if (!v || type === 'none') return cents;
        if (type === 'percent') return Math.max(0, cents - Math.round(cents * (v / 100)));
        if (type === 'amount')  return Math.max(0, cents - Math.round(v * 100));
        return cents;
    }

    // ---------- Delegated listeners ----------
    document.addEventListener('click', (e) => {
        function lrcPpuEvent(name) {
            try {
                const a = window.__lrcPpuArm;
                if (a && window.LRC_EXP && typeof window.LRC_EXP.event === 'function') {
                    window.LRC_EXP.event(a.key, a.arm, name);
                }
            } catch (err) {}
        }

        const addBtn = e.target.closest('button.lrc-drawer-add-to-cart-checkout, a.lrc-drawer-add-to-cart-checkout');
        if (addBtn) {
            e.preventDefault();
            if (addBtn.dataset.lrcLoading === '1') return;
            lrcPpuEvent('accepted');
            addToCartAndCheckout(addBtn);
            return;
        }

        const goBtn = e.target.closest('.lrc-drawer-go-to-checkout, a.lrc-drawer-go-to-checkout');
        if (goBtn) {
            e.preventDefault();
            if (goBtn.dataset.lrcLoading === '1') return; // prevent double taps
            lrcPpuEvent('declined');
            goToCheckout(goBtn);
        }
    });
})();




